export const GET_EMAIL_EVENTS = "GET_EMAIL_EVENTS"
export const GET_EMAIL_EVENTS_SUCCESS = "GET_EMAIL_EVENTS_SUCCESS"
export const GET_EMAIL_EVENTS_ERROR = "GET_EMAIL_EVENTS_ERROR"

/*
 * EMAIL Create
*/
export const CREATE_EMAIL = "CREATE_EMAIL"
export const CREATE_EMAIL_SUCCESS = "CREATE_EMAIL_SUCCESS"
export const CREATE_EMAIL_ERROR = "CREATE_EMAIL_ERROR"

/*
 * Update EMAIL - Will we need updating?
 */

export const UPDATE_EMAIL = "UPDATE_EMAIL"
export const UPDATE_EMAIL_SUCCESS = "UPDATE_EMAIL_SUCCESS"
export const UPDATE_EMAIL_ERROR = "UPDATE_EMAIL_ERROR"

export const UPDATE_CURRENT_EMAIL = "UPDATE_CURRENT_EMAIL"

export const RESET_EMAIL_ERROR = "RESET_EMAIL_ERROR"

// For Email-Events-Update-Templates

export const GET_EMAIL_TEMPLATE_BY_ID = "GET_EMAIL_TEMPLATE_BY_ID"
export const GET_EMAIL_TEMPLATE_BY_ID_SUCCESS = "GET_EMAIL_TEMPLATE_BY_ID_SUCCESS"
export const GET_EMAIL_TEMPLATE_BY_ID_ERROR = "GET_EMAIL_TEMPLATE_BY_ID_ERROR"

export const CHECK_EMAIL_STATUS_BY_EVENT = "CHECK_EMAIL_STATUS_BY_EVENT"
export const CHECK_EMAIL_STATUS_BY_EVENT_SUCCESS = "CHECK_EMAIL_STATUS_BY_EVENT_SUCCESS"
export const CHECK_EMAIL_STATUS_BY_EVENT_ERROR = "CHECK_EMAIL_STATUS_BY_EVENT_ERROR"

export const DELETE_EMAIL_STATUS_BY_EVENT = "DELETE_EMAIL_STATUS_BY_EVENT"
export const DELETE_EMAIL_STATUS_BY_EVENT_SUCCESS = "DELETE_EMAIL_STATUS_BY_EVENT_SUCCESS"
export const DELETE_EMAIL_STATUS_BY_EVENT_ERROR = "DELETE_EMAIL_STATUS_BY_EVENT_ERROR"

// FOR RESET EMAIL LOGS
export const RESET_EMAIL_TEMPLATE_BY_ID = "RESET_EMAIL_TEMPLATE_BY_ID"